// frontend\src\hooks\useTelegramBot.js
import { useState, useEffect } from 'react';
import api from '../api/api';

export const useTelegramBot = (authTokens) => {
  const [botUsername, setBotUsername] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBotInfo = async () => {
      if (!authTokens?.access) return;
      
      try {
        const response = await api.get('/telegram/bot-info/', {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        });
        setBotUsername(response.data.bot_username);
      } catch (error) {
        console.error('Ошибка загрузки информации о боте:', error);
        // Значение по умолчанию на случай ошибки
        setBotUsername('photochemistry_bot');
      } finally {
        setLoading(false);
      }
    };

    fetchBotInfo();
  }, [authTokens]);

  return { botUsername, loading };
};